module.exports = __webpack_public_path__ + "img/icon-USOT.95abea94.svg";